import {
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import styled from "styled-components";
import { CLOUDN_COLORS } from "../../../constants/colors";
import PublicStyledTableCell from "../../publics/PublicStyledTableCell";
import AllDeviceConnectionTableRow from "../../atoms/all/AllDeviceConnectionTableRow";
import { AllDeviceConnectionTableProps } from "../../../constants/types";
import { useEffect, useState } from "react";

const AllDeviceConnectionTable = (props: AllDeviceConnectionTableProps) => {
  const [rows, setRows] = useState<JSX.Element[]>([]);

  useEffect(() => {
    setRows(
      props.data.map((data, index) => (
        <AllDeviceConnectionTableRow
          connected={data.total - data.disconnectedDevice}
          name={data.name}
          total={data.total}
          key={index}
        />
      ))
    );
  }, [props.data]);

  return (
    <Container>
      <TableContainer
        sx={{
          width: "100%",
          height: "100%",
          borderBottom: `2px solid ${CLOUDN_COLORS.logoSkyBlue}`,
        }}
      >
        <Table
          style={{
            width: "100%",
            borderSpacing: 0,
          }}
          stickyHeader
        >
          <TableHead>
            <TableRow>
              <PublicStyledTableCell width={60}>
                프로젝트 명
              </PublicStyledTableCell>
              <PublicStyledTableCell>
                통신기기 수량 (현재/전체)
              </PublicStyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>{rows}</TableBody>
        </Table>
      </TableContainer>
    </Container>
  );
};

export default AllDeviceConnectionTable;

const Container = styled.div`
  width: 100%;
  height: 88%;
`;
